import { useState } from 'react';

import { useQuery } from '@apollo/client';
import { Tab, Tabs, Box, Typography } from '@mui/material';
import { EventCard } from '@scorenco/components';
import { RouteLink, useTranslation } from '@scorenco/core';
import { useRouter } from 'next/router';

import { TabPanel } from '@/components';
import { T_KEYS } from '@/translations';

import { GetPreviousAndNextEventsDocument } from './_internal/Widget.query.generated';

export const PreviousNextWidget = ({ team }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const [currentTab, setCurrentTab] = useState(1);
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const getPreviousAndNextEvents = useQuery(GetPreviousAndNextEventsDocument, {
    variables: {
      teamId: Number(team?.team_id),
      cacheTTL: router.query.noCache ? 0 : undefined,
    },
    skip: !team?.team_id,
    context: {
      role: 'anonymous',
    },
  });

  return (
    <Box
      className="previous-next-widget"
      sx={{ width: '100%', marginBottom: '1.5rem' }}
    >
      <Box
        className="tabs-container"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tabs
          value={currentTab}
          onChange={handleChangeTab}
          centered
          variant="fullWidth"
          className="tabs"
        >
          <Tab label={t(T_KEYS.PREVIOUS_EVENT)} className="tab-previous" />
          <Tab label={t(T_KEYS.NEXT_EVENT)} className="tab-next" />
        </Tabs>
      </Box>
      <TabPanel value={currentTab} index={0} className="tab-panel-previous">
        {!getPreviousAndNextEvents.data?.previousEvent[0] ? (
          <Typography
            variant="h5"
            className="no-event-message"
            sx={{
              textAlign: 'center',
              padding: '0.5rem',
              mt: '1rem',
            }}
          >
            Aucun match n'a été trouvé pour cette équipe
          </Typography>
        ) : (
          <RouteLink
            href={
              getPreviousAndNextEvents.data?.previousEvent[0]?.old_url &&
              process.env.NEXT_PUBLIC_WEB_URL +
                getPreviousAndNextEvents.data?.previousEvent[0]?.old_url
            }
          >
            <EventCard
              event={getPreviousAndNextEvents.data?.previousEvent[0]}
              className="event-card"
            />
          </RouteLink>
        )}
      </TabPanel>

      <TabPanel value={currentTab} index={1} className="tab-panel-next">
        {!getPreviousAndNextEvents.data?.nextEvent[0] ? (
          <Typography
            variant="h5"
            className="no-event-message"
            sx={{
              textAlign: 'center',
              padding: '0.5rem',
              mt: '1rem',
            }}
          >
            Aucun match n'a été trouvé pour cette équipe
          </Typography>
        ) : (
          <RouteLink
            href={
              getPreviousAndNextEvents.data?.nextEvent[0]?.old_url &&
              process.env.NEXT_PUBLIC_WEB_URL +
                getPreviousAndNextEvents.data?.nextEvent[0]?.old_url
            }
          >
            <EventCard
              event={getPreviousAndNextEvents.data?.nextEvent[0]}
              className="event-card"
            />
          </RouteLink>
        )}
      </TabPanel>
    </Box>
  );
};
